/**
 * The few glyphs the admin UI needs, inline so there is no icon dependency and
 * no extra request. Each one inherits the text colour and the font size, which
 * is what `1em` and `currentColor` are for.
 */
const base = {
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": 1.5,
  "stroke-linecap": "round" as const,
  "stroke-linejoin": "round" as const,
  "aria-hidden": true as const,
};

/** Edit: a pencil over the thing it changes. */
export const PencilIcon = () => (
  <svg {...base}>
    <path d="M11.2 2.3a1.1 1.1 0 0 1 1.6 0l0.9 0.9a1.1 1.1 0 0 1 0 1.6L6.1 11.4l-2.9 0.8 0.8-2.9z" />
    <path d="M10.2 3.3l2.5 2.5" />
  </svg>
);

/** Collapse the rail: a chevron pointing at the edge it folds against. */
export const ChevronLeftIcon = () => (
  <svg {...base}>
    <path d="M9.5 3.5L5 8l4.5 4.5" />
  </svg>
);

/** Expand the rail again. */
export const MenuIcon = () => (
  <svg {...base}>
    <path d="M2.5 4.5h11M2.5 8h11M2.5 11.5h11" />
  </svg>
);

/** A collapsed branch, pointing at what unfolding it would reveal. */
export const ChevronRightIcon = () => (
  <svg {...base}>
    <path d="M6.5 3.5L11 8l-4.5 4.5" />
  </svg>
);

/** An unfolded branch. */
export const ChevronDownIcon = () => (
  <svg {...base}>
    <path d="M3.5 6.5L8 11l4.5-4.5" />
  </svg>
);

/** Unfold every branch: two chevrons pointing away from each other. */
export const UnfoldIcon = () => (
  <svg {...base}>
    <path d="M4 6.5L8 2.5l4 4" />
    <path d="M4 9.5L8 13.5l4-4" />
  </svg>
);

/** Fold every branch: the same two chevrons, pointing at each other. */
export const FoldIcon = () => (
  <svg {...base}>
    <path d="M4 2.5L8 6.5l4-4" />
    <path d="M4 13.5L8 9.5l4 4" />
  </svg>
);

/** Dismiss a dialog. */
export const CloseIcon = () => (
  <svg {...base}>
    <path d="M4 4l8 8M12 4l-8 8" />
  </svg>
);

/** Delete: a waste bin, for the one action that cannot be undone by clicking again. */
export const TrashIcon = () => (
  <svg {...base}>
    <path d="M2.5 4.5h11" />
    <path d="M6.5 4.5V3a0.5 0.5 0 0 1 0.5-0.5h2a0.5 0.5 0 0 1 0.5 0.5v1.5" />
    <path d="M4 4.5l0.6 8a1 1 0 0 0 1 0.9h4.8a1 1 0 0 0 1-0.9l0.6-8" />
    <path d="M6.8 7v3.6M9.2 7v3.6" />
  </svg>
);

/** Compare: one subject, a row of readings beside it. */
export const CompareIcon = () => (
  <svg {...base}>
    <path d="M2.5 3.5h11M2.5 8h11M2.5 12.5h11" />
    <path d="M6 2v12" />
  </svg>
);

/** Reasoning attached to a value: a speech bubble with a line of text in it. */
export const NoteIcon = () => (
  <svg {...base}>
    <path d="M3 3.5h10a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H7.5L4.5 14v-2.5H3a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1z" />
    <path d="M5 7.5h6" />
  </svg>
);
